import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';
import DeviceDetails from "../LoginComponent/DeviceDetails";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { setPersonalInfo, setRegisterRetailerResponse } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import FooterComponet from "../FooterComponent/FooterComponet";

import { legacy_createStore } from "redux";
import tokenErrorHandler from "../tokenErrorHandler";
import RegisterRetialerHeader from "../HeaderComponent/RegisterRetialerHeader";
import { setBranchAddress, setIfscCode, setSelectedBankName } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class RegisterRetailer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gender: '',
            deviceInfo: '',
            retailerFirstName: '',
            retailerLastName: '',
            dob: '',
            mobile: '',
            email: '',
            mobileErrMsg: '',
            emailErrMsg: '',
            firstNameErrMsg: '',
            lastNameErrMsg: '',
            dobErrMsg: '',
            genderErrMsg: '',
            sessionErr: '',
            progress: ''

        }
    }





    componentDidMount() {

        store.dispatch(setIfscCode(''));
        store.dispatch(setBranchAddress(''));
        store.dispatch(setSelectedBankName(''));

        const deviceInfo = DeviceDetails.fetchDeviceInfo();
        deviceInfo.then((deviceResponse) => {
            this.setState({
                deviceInfo: deviceResponse
            })
        })

        


    }
    componentWillUnmount() {
    }




    selectAction(event) {
        this.setState({
            gender: event.target.value,
            genderErrMsg: ''
        })
    }


    validateName() {

        // var regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
        var firstnameValidation = true;
        var lastNameValidation = true;
        var regName = /^[a-zA-Z ]*$/;

        if (this.state.retailerFirstName == '') {
            this.setState({
                firstNameErrMsg: 'Please enter first name'
            })
            firstnameValidation = false;
        } else if (!regName.test(this.state.retailerFirstName)) {
            this.setState({
                firstNameErrMsg: 'Name should contains alphabets only'
            })
            firstnameValidation = false;
        }


        if (this.state.retailerLastName == '') {
            this.setState({
                lastNameErrMsg: 'Please enter last name'
            })
            lastNameValidation = false;
        } else if (!regName.test(this.state.retailerLastName)) {
            this.setState({
                lastNameErrMsg: 'Name should contains alphabets only'
            })
            lastNameValidation = false;
        }

        if (firstnameValidation == true && lastNameValidation == true) {
            return true;
        } else {
            return false;
        }
    }

    // validateGovernmentId() {
    //     var aadhRegx = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/;
    //     var voterRegx = /^([a-zA-Z]){3}([0-9]){7}?$/;
    //     var drivingLicenseRegex = /^([A-Z]{2})(\d{2}|\d{3})[a-zA-Z]{0,1}(\d{4})(\d{7})$/;
    //     var panCardRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
    //     var passportRegex = /^(?!^0+$)[a-zA-Z0-9]{6,9}$/;
    //     var regexVal = "";
    //     var regexFormat = "";

    //     if (this.state.senderGovtIdType == "AADHAAR_CARD") {
    //         regexVal = aadhRegx;
    //         regexFormat = 'xxxx xxxx xxxx';
    //     } else if (this.state.senderGovtIdType == "BILL_ADDRESS_PROOF") {
    //         regexVal = voterRegx;
    //         regexFormat = 'xxxxxxxxx';
    //     } else if (this.state.senderGovtIdType == "DRIVERS_LICENSE") {
    //         regexVal = drivingLicenseRegex;
    //         regexFormat = '';
    //     } else if (this.state.senderGovtIdType == "PAN_CARD") {
    //         regexVal = panCardRegex;
    //         regexFormat = 'xxxxxxxxx';
    //     } else if (this.state.senderGovtIdType == "PASSPORT") {
    //         regexVal = passportRegex;
    //         regexFormat = '';
    //     }

    //     var govtIdValue = this.state.senderGovtIdNumber;

    //     if (this.state.senderGovtIdType != "" && this.state.senderGovtIdType != "Select") {
    //         if (!regexVal.test(govtIdValue)) {
    //             if (regexFormat != '') {
    //                 alert('Please enter valid ' + this.state.senderGovtIdType + ' value in given format ' + regexFormat);
    //             } else {
    //                 alert('Please enter valid ' + this.state.senderGovtIdType + ' value');
    //             }
    //             return false;
    //         }
    //         else {
    //             // alert('Valid Id details given.');
    //             return true;
    //         }
    //     } else {
    //         alert('Please select any government Id.');
    //     }
    // }

    sessionCreateValidation() {
        this.setState({
            mobileErrMsg: '',
            emailErrMsg: '',
            firstNameErrMsg: '',
            lastNameErrMsg: '',
            dobErrMsg: '',
            genderErrMsg: '',
        })

        var nameValidation = this.validateName();
        var mobileValidation = false;
        if (this.state.mobile != '' && this.state.mobile.length == 10) {
            mobileValidation = true;
        } else {
            this.setState({
                mobileErrMsg: 'Please enter correct mobile'
            })
        }

        var emailValidation = false;
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (this.state.email != '' && emailRegex.test(this.state.email)) {
            emailValidation = true;
        } else {
            this.setState({
                emailErrMsg: 'Please enter correct mail'
            })
        }

        var dobValidation = false;
        if (this.state.dob != '') {

            dobValidation = true;
        } else {
            this.setState({
                dobErrMsg: 'Please select Date of Birth'
            })
        }

        var genderValidation = false;
        if (this.state.gender != '') {

            genderValidation = true;
        } else {
            this.setState({
                genderErrMsg: 'Please select gender'
            })
        }

        if (nameValidation == true && mobileValidation == true &&
            emailValidation == true && genderValidation == true &&
            dobValidation == true) {
            return true;

        } else {
            return false;
        }

    }

    checkRetailer = () => {
        httpClient.get('/api/v1/retailer/check/' + this.state.mobile,
            // { headers }
        ).then((response) => {
            console.log('register retailer response' + JSON.stringify(response.data));
        }).catch(error => {



        });

    }

    sessionCreate = (event) => {
        event.preventDefault();

        this.checkRetailer();

        this.setState({
            progress: 'loading',
            sessionErr: ''
        })

        if (this.sessionCreateValidation() == true) {


            httpClient.get('/api/v1/retailer/check/' + this.state.mobile,
                // { headers }
            ).then((response) => {
                console.log('register retailer response' + JSON.stringify(response.data));

                if(response.data.response.msg=='MOBILE_NOT_LINKED'){
                    var sessionCreateUrl = '/api/v1/retailer/onboard/session/create';

                    var header = {
                        msgType: "CREATE_ORDER",
                        service: "KYC",
                        src: "register-retailer",
                        dst: "register-retailer",
                        channel: "API",
                        requesterId: 'W9853028034FPAY',
                        requestId: uuidv4(),
                        traceId: uuidv4(),
                    }
                    var request = {
                        header: header,
                        deviceInfo: this.props.deviceInfo,
                        mobile: this.state.mobile
                    }
                   
        
                    console.log('register retailer req:' + JSON.stringify(request));
        
                    httpClient.post(sessionCreateUrl, request,
                        // { headers }
                    ).then((response) => {
                        console.log('register retailer response' + JSON.stringify(response.data));
        
                        store.dispatch(setRegisterRetailerResponse(response.data))
        
        
                        var dobArr = this.state.dob.split("-")
                        var dob = dobArr[2] + '/' + dobArr[1] + '/' + dobArr[0]
        
                        if (response.data.response.success == true) {
                            var personalInfo = {
                                gender: this.state.gender.toUpperCase(),
                                fname: this.state.retailerFirstName,
                                lname: this.state.retailerLastName,
                                email: this.state.email,
                                mobile: this.state.mobile,
                                dob: dob,
                                address: null,
                                selfie: ''
        
                            }
                            store.dispatch(setPersonalInfo(personalInfo));
        
                            this.setState({
                                progress: 'completed'
                            })
        
                            this.goToVerifyOtp();
                        } else {
                            this.renewSession();
                        }
        
                    }).catch(error => {
                        this.setState({
                            sessionErr: 'Something went wrong',
                            progress: 'completed'
                        })
                        if (error.message.includes("401")) {
                            tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                        } else {
        
                        }
              
        
                    });
                }
                if(response.data.response.msg=='SUCCESS'){
                    this.setState({
                        sessionErr:response.data.response.displayMsg,
                        progress:'commpleted'
                    })
                }
            }).catch(error => {
                this.setState({
                    sessionErr:'something went wrong!',
                    progress:'completed'
                })
            });
           
        }
        else {
            this.setState({
                progress: 'completed',
                sessionErr: ''
            })

        }



    }

    goToVerifyOtp = () => {
        var goToVerifyOtpBtn = document.getElementById('goToVerifyOtpBtn');
        goToVerifyOtpBtn.click();
    }

    renewSession = () => {

        this.setState({
            sessionErr: ''
        })
        var renewSessionUrl = '/api/v1/retailer/onboard/session/renew';
        var header = {
            msgType: "CREATE_ORDER",
            service: "KYC",
            src: "register-retailer",
            dst: "register-retailer",
            channel: "API",
            requesterId: 'W9853028034FPAY',
            requestId: uuidv4(),
            traceId: uuidv4(),
        }
        var request = {
            header: header,
            deviceInfo: this.props.deviceInfo,
            mobile: this.state.mobile
        }
        // const headers = {
        //     'Authorization': 'Bearer ' + this.props.token,
        //     'client-id': this.props.agentInfo.id,
        //     'role': this.props.clientRole
        // }
        console.log('renew retailer req:' + JSON.stringify(request));

        httpClient.post(renewSessionUrl, request,
            // { headers }
        ).then((response) => {
            console.log('register retailer renew response' + JSON.stringify(response.data));

            store.dispatch(setRegisterRetailerResponse(response.data))

            if (response.data.response.success == true) {

                // var dobArr=this.state.dob.split("-")
                // var dob=dobArr[2]+'/'+dobArr[1]+'/'+dobArr[0]

                // alert(dob)
                var personalInfo = {
                    gender: this.state.gender.toUpperCase(),
                    fname: this.state.retailerFirstName,
                    lname: this.state.retailerLastName,
                    email: this.state.email,
                    mobile: this.state.mobile,
                    dob: this.state.dob,
                    address: null,
                    selfie: ''

                }
                store.dispatch(setPersonalInfo(personalInfo))

                this.setState({
                    progress: 'completed'
                })
                this.goToVerifyOtp();
            } else {
                this.setState({
                    sessionErr: 'Something went wrong',
                    progress: 'completed'
                })

            }

        }).catch(error => {
            this.setState({
                sessionErr: 'Something went wrong',
                progress: 'completed'
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }


        });
    }


    enterRetaileFirstName = (event) => {
        this.setState({
            firstNameErrMsg: '',
            retailerFirstName: event.target.value
        })
    }
    enterRetaileLastName = (event) => {
        this.setState({
            lastNameErrMsg: '',
            retailerLastName: event.target.value
        })
    }
    enterMobile = (event) => {
        this.setState({
            mobileErrMsg: '',
            mobile: event.target.value
        })
    }
    enterEmail = (event) => {
        this.setState({
            emailErrMsg: '',
            email: event.target.value
        })
    }
    enterDOB = (event) => {


        this.setState({
            dobErrMsg: '',
            dob: event.target.value
        })
    }


    render() {

        return (
            <div>
                <RegisterRetialerHeader />
                {/* <RegisterRetailerMenu /> */}
                <div class="mid-contant1">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="main-heading">
                                    <h2>Register as a retailer</h2>
                                </div>
                                <Link to='/verify-otp-retailer'>
                                    <button id='goToVerifyOtpBtn' hidden={true}></button>
                                </Link>
                            </div>
                            <div class="col-12">
                                <div class="registerbox">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            <form onSubmit={this.sessionCreate}>
                                                <div class="row">
                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="firsname" placeholder="Enter first name" value={this.state.retailerFirstName}
                                                                onChange={this.enterRetaileFirstName}
                                                            />
                                                            <label for="firsname">First name</label>
                                                        </div>
                                                        {this.state.firstNameErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.firstNameErrMsg}
                                                            </div>}
                                                    </div>


                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="lastname" placeholder="Enter last name" value={this.state.retailerLastName}
                                                                onChange={this.enterRetaileLastName}
                                                            />
                                                            <label for="lastname">Last name</label>
                                                        </div>
                                                        {this.state.lastNameErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.lastNameErrMsg}
                                                            </div>}
                                                    </div>


                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="number" class="form-control" id="mobile" placeholder="Enter mobile no." value={this.state.mobile}
                                                                onChange={this.enterMobile}
                                                                onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                            />
                                                            <label for="mobile">Mobile number</label>
                                                        </div>
                                                        {this.state.mobileErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.mobileErrMsg}
                                                            </div>}

                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="email" placeholder="Enter email id" value={this.state.email}
                                                                onChange={this.enterEmail}
                                                            />
                                                            <label for="email">Email ID</label>
                                                        </div>
                                                        {this.state.emailErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.emailErrMsg}
                                                            </div>}
                                                    </div>


                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="date" class="form-control" id="dob" placeholder="Date of Birth" value={this.state.dob}
                                                                onChange={this.enterDOB}
                                                            />
                                                            <label for="dob">Date of Birth</label>
                                                        </div>
                                                        {this.state.dobErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.dobErrMsg}
                                                            </div>}
                                                    </div>


                                                    <div class="col-12 col-md-6">
                                                        <div class="form-checkbox">
                                                            <label class="label-txt">Gender </label>
                                                            <div onChange={this.selectAction.bind(this)}
                                                            >
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="radio" name="gender" id="male" value="Male" />
                                                                    <label class="form-check-label" for="male">Male</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="radio" name="gender" id="female" value="female" />
                                                                    <label class="form-check-label" for="female">Female</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="radio" name="gender" id="other" value="other" />
                                                                    <label class="form-check-label" for="other">Other</label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {this.state.genderErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.genderErrMsg}
                                                            </div>}
                                                    </div>



                                                    {/* <div class="col-12 mt-4">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox" value="" id="tnc" checked />
                                                            <label class="form-check-label tnc" for="tnc">By registering, you confirm that you accept our <a href="#">terms and conditions</a></label>
                                                        </div>
                                                    </div> */}

                                                    <div class="col-12">
                                                        <button type="submit" class="btn btn-primary" id="proceed"
                                                            disabled={this.state.progress == 'loading' && true}
                                                        >Proceed</button>
                                                    </div>
                                                    {this.state.sessionErr != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.sessionErr}
                                                        </div>}
                                                </div>
                                            </form>
                                        </div>

                                        <div class="col-12 col-lg-5 d-none d-lg-block">

                                            <div class="rightbanner"><img src="images/register.png" alt="Oxigen" class="img-fluid" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponet />
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, deviceInfo, token, clientRole, agentInfo, callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, deviceInfo, token, clientRole, agentInfo, callBackUrl
});

export default connect(mapStateToProps, null)(RegisterRetailer);
